const CORA_USER_AGENT = 'CORA'

// Cora's integrated browser (WebView2) exposes this exact User-Agent (BUILD-488)
export function isCoraContext(): boolean {
  return navigator.userAgent === CORA_USER_AGENT
}
